<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h2 class="mb-4">Coach Allocation</h2>

        <v-data-table :headers="headers" :items="users" :items-per-page="100" dense class="mt-2 elevation-2">
          <template v-slot:item.coach="{ item }">
            <v-avatar size="35" color="grey">
              <img
                v-if="item.userProfile.profilePicture"
                :src="item.userProfile.profilePicture"
                :lazy-src="item.userProfile.profilePicture"
              />
            </v-avatar>
            <span class="ml-2"> {{ item.firstName }} {{ item.lastName }} </span>
          </template>

          <template v-slot:item.oneOnOneClients="{ item }">
            {{ item.userProfile.oneOnOneClients }}
          </template>

          <template v-slot:item.clubClients="{ item }">
            {{ item.userProfile.clubClients }}
          </template>

          <template v-slot:item.corporateClubClients="{ item }">
            {{ item.userProfile.corporateClubClients }}
          </template>

          <template v-slot:item.oneOnOneClientAllocation="{ item }">
            <v-text-field
              :value="item.userProfile.oneOnOneClientAllocation"
              @input="setAllocation($event, 'oneOnOneClientAllocation', item.id)"
            />
          </template>
          <template v-slot:item.clubClientAllocation="{ item }">
            <v-text-field
              :value="item.userProfile.clubClientAllocation"
              @input="setAllocation($event, 'clubClientAllocation', item.id)"
            />
          </template>
          <template v-slot:item.corporateClientAllocation="{ item }">
            <v-text-field
              :value="item.userProfile.corporateClientAllocation"
              @input="setAllocation($event, 'corporateClientAllocation', item.id)"
            />
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { STAFF_QUERY } from "@/constants/graphql/users/user";
import { UPDATE_PROFILE_MUTATION } from "@/constants/graphql/client/client";
import { extractNodes } from "@/lib/array";
import { decodeId } from "@/lib/string";

export default {
  name: "CoachAllocation",
  data() {
    return {
      headers: [
        { text: "Coach", value: "coach" },
        { text: "1-on-1 Clients", value: "oneOnOneClients" },
        { text: "Club Clients (ex Corporate)", value: "clubClients" },
        { text: "Corporate Club Clients", value: "corporateClubClients" },
        { text: "1-1 Client Allocation", value: "oneOnOneClientAllocation" },
        { text: "Club Client Allocation", value: "clubClientAllocation" },
        { text: "Corporate Client Allocation", value: "corporateClientAllocation" },
      ],
    };
  },
  methods: {
    setAllocation(value, type, userId) {
      const input = {
        userId: decodeId(userId),
      };
      input[type] = value;
      this.$apollo.mutate({
        mutation: UPDATE_PROFILE_MUTATION,
        variables: {
          userProfileInput: input,
        },
      });
    },
  },
  apollo: {
    users: {
      query: STAFF_QUERY,
      variables() {
        return {
          isActive: true,
          isStaff: true,
          userProfile_UserType: "Coach",
        };
      },
      update(data) {
        const nodes = extractNodes(data.users.edges);
        // no sorting on the built in users relay node. 
        return nodes.sort((a, b) => (a.firstName > b.firstName ? 1 : -1));
      },
    },
  },
};
</script>
